var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4ab89a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.9075 22c-.0374 0-.0756-.0018-.113-.0071h-17.73229c-.03648.0044-.07295.0062-.10943.0062-.46973 0-.86562-.3354-.94035-.798-.03825-.2358.01246-.4751.14323-.6743l8.97734-17.95298c.2589-.51866.6423-.57382.7954-.57382.1903 0 .5462.07473.7953.57382l8.9774 17.95378c.2766.4208.1708.9982-.2394 1.2936-.1628.1165-.354.1788-.5542.1788zm-17.96895-1.048c-.01068.0205-.02224.0409-.03648.0596-.01067.0151-.01423.0303-.01156.0463.00533.032.0338.0516.05871.0516.0347-.0054.05872-.0071.08274-.0071h17.79284c.024 0 .048.0017.072.0062h.0071c.0178 0 .0276-.0036.0374-.0107.0276-.0196.0338-.0578.0142-.0854-.0133-.0178-.0258-.0383-.0364-.0596l-8.9907-17.98141z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9284 16.2138c-.2456 0-.4449-.1993-.4449-.4448v-6.22752c0-.24554.1993-.44482.4449-.44482.2455 0 .4448.19928.4448.44482v6.22752c0 .2455-.1993.4448-.4448.4448z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9408 18.4379c-.3665-.0009-.6645-.2838-.6788-.645-.0035-.1842.0614-.3541.1842-.4831.1227-.129.2882-.2028.4661-.2055.3773.0071.6699.2909.6833.6459.0035.1841-.0614.3541-.1842.4831-.1227.129-.2882.2019-.4661.2055 0 0-.0027-.0009-.0045-.0009z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoProblem);
export default __webpack_public_path__ + "static/media/ico_problem.e95ce255e6d46d17474e9a804b6efc99.svg";
export { ForwardRef as ReactComponent };